export default "__VITE_ASSET__DO0cDnLT__"